import { DEFAULT_CDN_URL, parseStylesheetSource } from '../cdn.js';
import { loadStylesheet } from '../dom/stylesheet.js';
import { FEAASElement } from './FEAASElement.js';
export function FEAASStylesheetProps(element) {
    var _a, _b, _c, _d;
    const src = element.getAttribute('src');
    if (src) {
        var { cdn, library, revision } = parseStylesheetSource(src);
    }
    return {
        library: element === null || element === void 0 ? void 0 : element.getContextAttribute('library'),
        revision: (_b = (_a = element === null || element === void 0 ? void 0 : element.getAttribute('revision')) !== null && _a !== void 0 ? _a : revision) !== null && _b !== void 0 ? _b : 'published',
        cdn: (_d = (_c = element === null || element === void 0 ? void 0 : element.getContextAttribute('cdn')) !== null && _c !== void 0 ? _c : element === null || element === void 0 ? void 0 : element.getContextAttribute('hostname')) !== null && _d !== void 0 ? _d : DEFAULT_CDN_URL
    };
}
export class FEAASStylesheet extends FEAASElement {
    constructor() {
        super(...arguments);
        this.onLoad = (html) => {
            this.payload = html;
            this.advance();
        };
    }
    getProps() {
        return FEAASStylesheetProps(this);
    }
    isReadyToLoad() {
        return this.props.library != null && this.props.revision != null && this.props.cdn != null;
    }
    load() {
        return loadStylesheet(this.props, this.onLoad);
    }
}
FEAASStylesheet.register('feaas-stylesheet');
export { FEAASStylesheet as Stylesheet };
//# sourceMappingURL=FEAASStylesheet.js.map